import {
    Badge,
    Button,
    Box,
    Flex,
    Heading,
    HStack,
    Checkbox,
    Img,
    Text,
    FormControl,
    FormLabel,
    Input,
    Stack,
    useColorModeValue as mode,
    Link,
    Image,
} from '@chakra-ui/react'
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import goodworkLogo from '../../../assets/images/logo-black.svg';
import SessionContext from '../../../context/SessionContext';
import UnderlineLink from '../../ui/underline-link/UnderlineLink';

function PasswordRecoveryForm() {
    const history = useHistory();
    const { login } = useContext(SessionContext);

    const [rememberMe, setRememberMe] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    return (
        <Box
            margin={{base: '0 auto', lg: '0'}}
            flex="0 0 auto"
            maxW="500px"
            mb={10}
            bgColor="white"
            display="flex"
            flexDirection="column"
            justifyContent="stretch"
            alignItems="stretch"
            alignSelf={{base: 'center', lg: 'flex-start'}}
        >
            <Heading size="md" mb={2}>Forgot your password?</Heading>
            <Text mb={8}>Enter your email, and we will send a password recovery link.</Text>
            <Stack spacing="-px">
                <FormControl id="email-address">
                    <FormLabel srOnly>Email address</FormLabel>
                    <Input
                    size="lg"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    placeholder="Email address"
                    bg={mode('white', 'gray.700')}
                    fontSize="md"
                    />
                </FormControl>
            </Stack>
            <Button
                size="lg"
                type="submit"
                mt="4"
                w="full"
                colorScheme="blue"
                fontSize="md"
                fontWeight="bold"
            >
                Send Email
            </Button>
            <Flex align="center" justify="flex-end" mt={4}>
                <UnderlineLink fontSize="sm" href={'/auth/login'}>Back to Login</UnderlineLink>
            </Flex>
            <Box h={10} />
        </Box>
    )
}

export default PasswordRecoveryForm;